export default function formatError({
  status,
  message,
}: {
  status?: number;
  message?: string;
}): string {
  if (status === 404) {
    return `This item doesn't exist.`;
  }

  return message || `An error occurred, please try again.`;
}
